import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Artists from "@/pages/Artists";
import Suppliers from "@/pages/Suppliers";
import ArtistDetail from "@/pages/ArtistDetail";
import SocialCallback from "@/pages/SocialCallback";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Store from "@/pages/Store";
import Eventi from "@/pages/Eventi";
import ChiaviInMano from "@/pages/ChiaviInMano";
import Pacchetti from "@/pages/Pacchetti";
import ProductDetail from "@/pages/ProductDetail";
import FAQ from "@/pages/FAQ";
import Legal from "@/pages/Legal";
import Dashboard from "@/pages/Dashboard";
import Chat from "@/pages/Chat";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Subscription from "@/pages/Subscription";
import PaymentSuccess from "@/pages/PaymentSuccess";
import ContractArchive from "@/pages/ContractArchive";
import Admin from "@/pages/Admin";
import SearchResults from "@/pages/SearchResults";
import Plans from "@/pages/Plans";
import { RouteTracker } from "@/components/RouteTracker";
import { RecommendedBar } from "@/components/RecommendedBar";
import { CookieBanner } from "@/components/CookieBanner";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Toaster position="top-right" offset={88} richColors />
        <Navbar />
        <CookieBanner />
        <main className="min-h-[70vh]">
          <RouteTracker />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/artisti" element={<Artists />} />
            <Route path="/vetrina" element={<Artists />} />
            <Route path="/consigliati" element={<Artists />} />
            <Route path="/fornitori" element={<Suppliers />} />
            <Route path="/artista/:id" element={<ArtistDetail />} />
            <Route path="/login" element={<Login />} />
            <Route path="/accesso-social" element={<SocialCallback />} />
            <Route path="/registrati" element={<Register />} />
            <Route path="/store" element={<Store />} />
            <Route path="/store/prodotto/:id" element={<ProductDetail />} />
            <Route path="/eventi" element={<Eventi />} />
            <Route path="/chiavi-in-mano" element={<ChiaviInMano />} />
            <Route path="/pacchetti" element={<Pacchetti />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/privacy" element={<Legal doc="privacy" />} />
            <Route path="/cookie-policy" element={<Legal doc="cookie" />} />
            <Route path="/termini" element={<Legal doc="termini" />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/contratti" element={<ContractArchive />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/cerca" element={<SearchResults />} />
            <Route path="/piani" element={<Plans />} />
            <Route path="/chat" element={<Chat />} />
            <Route path="/password-dimenticata" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/abbonamento" element={<Subscription />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
        <Footer />
        <RecommendedBar />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
